import constants from '../../../../common/constants';

const form_name = 'registerForm';

const visible_all = 'all';

const fields = {
  first_name: 'first_name',
  last_name: 'last_name',
  country: 'addr_country',
  email: 'email',
  user_name: 'username',
  password: 'password',
  confirm_password: 'confirm_password',
  phone_number: 'telephone',
  user_type: 'user_type',
  client_communication: 'client_communication',
  managing_funds: 'managing_funds',
  coaching_clients: 'coaching_clients',
  money_manager: 'money_manager',
  tied_agent: 'tied_agent',
  skype: 'skype',
  website: 'website',
  target: 'target_region',
  terms: 'terms',
  status: 'status',
};

const user_types = {
  ib: 'IB',
  affiliate: 'P',
  educator: 'ED',
  fund_manager: 'FM',
  regional_office: 'RO',
  tied_agent: 'TA',
  ib_type: 'IBS',
  ifs_type: 'IFS',
  b2b: 'B2B',
  ibs: 'IBS',
};

const user_status = {
  individual: 'individual',
  company: 'company',
};

const form_steps = {
  1: {
    value: '1',
    path: '/register/2',
    fields: [
      {
        name: fields.country,
        required: true,
        label: 'REGISTER.COUNTRY',
        type: constants.input_types.select,
        option_label: 'name',
        option_value: 'code',
        visible: visible_all,
      },
      {
        name: 'title',
        required: true,
        label: 'REGISTER.SALUTATION',
        type: constants.input_types.select,
        options: [
          {
            value: 1,
            text: 'REGISTER.SALUTATION_MR',
          },
          {
            value: 2,
            text: 'REGISTER.SALUTATION_MS',
          },
          {
            value: 3,
            text: 'REGISTER.SALUTATION_MRS',
          },
          {
            value: 5,
            text: 'REGISTER.SALUTATION_DR',
          },
        ],
        option_label: 'text',
        option_value: 'value',
        visible: visible_all,
      },
      {
        name: fields.first_name,
        required: true,
        required_error: 'REGISTER.FIRST_NAME_REQUIRED',
        label: 'REGISTER.FIRST_NAME',
        type: constants.input_types.text,
        visible: visible_all,
      },
      {
        name: fields.last_name,
        required: true,
        required_error: 'REGISTER.LAST_NAME_REQUIRED',
        label: 'REGISTER.LAST_NAME',
        type: constants.input_types.text,
        visible: visible_all,
      },
      {
        name: fields.user_name,
        required: true,
        username_validate: true,
        skip_username_validation_field: fields.status,
        skip_username_validation_value: user_status.company,
        required_error: 'LOGIN.USERNAME_REQUIRED',
        label: 'REGISTER.USERNAME',
        alternative_label: 'REGISTER.COMPANY_NAME',
        type: constants.input_types.text,
        visible: visible_all,
      },
      {
        name: fields.email,
        required: true,
        required_error: 'REGISTER.EMAIL_REQUIRED',
        email_validate: true,
        label: 'REGISTER.EMAIL',
        type: constants.input_types.text,
        visible: visible_all,
      },
      {
        name: fields.password,
        required: true,
        password_validate: true,
        label: 'REGISTER.PASSWORD',
        required_error: 'LOGIN.PASSWORD_REQUIRED',
        type: constants.input_types.password,
        visible: visible_all,
      },
      {
        name: fields.confirm_password,
        required: true,
        match_validate: true,
        match_field: fields.password,
        match_error: 'REGISTER.CONFIRM_PASSWORD_MATCH',
        required_error: 'REGISTER.CONFIRM_PASSWORD_REQUIRED',
        label: 'REGISTER.CONFIRM_PASSWORD',
        type: constants.input_types.password,
        visible: visible_all,
      },
      {
        name: fields.phone_number,
        required: true,
        required_error: 'REGISTER.PHONE_NUMBER_REQUIRED',
        label: 'REGISTER.PHONE_NUMBER',
        type: constants.input_types.text,
        visible: visible_all,
      },
      {
        name: fields.skype,
        label: 'REGISTER.SKYPE',
        type: constants.input_types.text,
        visible: visible_all,
      },
      {
        name: fields.terms,
        required: true,
        id: 'term-checkbox',
        label: 'REGISTER.I_ACCEPT',
        externalUrlLabel: 'REGISTER.TERMS_AND_CONDITIONS',
        type: constants.input_types.checkbox,
        visible: user_types.ifs_type,
      },
    ],
  },
  2: {
    value: '2',
    fields: [
      {
        name: fields.client_communication,
        required: true,
        label: 'REGISTER.CLIENT_COMMUNICATION',
        type: constants.input_types.select,
        options: constants.choice_selection,
        option_label: 'text',
        option_value: 'value',
        visible: user_types.affiliate,
      },
      {
        name: fields.managing_funds,
        required: true,
        label: 'REGISTER.MANAGING_FUNDS',
        type: constants.input_types.select,
        options: constants.choice_selection,
        option_label: 'text',
        option_value: 'value',
        visible: user_types.ib,
      },
      {
        name: fields.coaching_clients,
        label: 'REGISTER.COACHING_CLIENTS',
        type: constants.input_types.select,
        options: constants.choice_selection,
        visible_field: fields.managing_funds,
        visible_field_value: false,
        option_label: 'text',
        option_value: 'value',
        visible: user_types.ib,
      },
      {
        name: fields.money_manager,
        label: 'REGISTER.MONEY_MANAGER',
        type: constants.input_types.select,
        options: constants.choice_selection,
        visible_field: fields.managing_funds,
        visible_field_value: true,
        option_label: 'text',
        option_value: 'value',
        visible: user_types.ib,
      },
      {
        name: fields.tied_agent,
        label: 'REGISTER.TIED_AGENT',
        type: constants.input_types.select,
        options: constants.choice_selection,
        visible_field: fields.money_manager,
        visible_field_value: false,
        option_label: 'text',
        option_value: 'value',
        visible: user_types.ib,
      },
      {
        name: fields.website,
        label: 'REGISTER.WEBSITE',
        type: constants.input_types.url,
        visible: visible_all,
      },
      {
        name: fields.target,
        label: 'REGISTER.TARGET_GEO',
        type: constants.input_types.text,
        visible: visible_all,
      },
      {
        name: fields.terms,
        required: true,
        id: 'term-checkbox',
        label: 'REGISTER.I_ACCEPT',
        externalUrlLabel: 'REGISTER.TERMS_AND_CONDITIONS',
        type: constants.input_types.checkbox,
        visible: visible_all,
      },
    ],
  },
};

const status_options = [
  {
    value: user_status.individual,
    label: 'REGISTER.STATUS_INDIVIDUAL',
  },
  {
    value: user_status.company,
    label: 'REGISTER.STATUS_COMPANY',
  },
];

const currency_options = [
  {
    value: constants.currencies.usd.value,
    label: constants.currencies.usd.text,
  },
  {
    value: constants.currencies.eur.value,
    label: constants.currencies.eur.text,
  },
];

const user_type_options = [
  {
    value: user_types.affiliate,
    pre_label: 'REGISTER.AFFILIATE_TYPE',
    label: 'REGISTER.AFFILIATE_TYPE_LABEL',
  },
  {
    value: user_types.ib,
    pre_label: 'REGISTER.IB_TYPE',
    label: 'REGISTER.IB_TYPE_LABEL',
  },
  {
    value: user_types.ifs_type,
    pre_label: 'REGISTER.IFS_TYPE',
    label: 'REGISTER.IFS_TYPE_LABEL_DESC',
  },
  {
    value: user_types.b2b,
    pre_label: 'REGISTER.B2B_TYPE',
    label: 'REGISTER.B2B_TYPE_LABEL',
    hidden: constants.is_prod_env,
  },
];

const all_user_types = [
  {
    value: user_types.affiliate,
    pre_label: 'USER_TYPES.AFFILIATE',
  },
  {
    value: user_types.ib,
    pre_label: 'USER_TYPES.INTRODUCER',
  },
  {
    value: user_types.ifs_type,
    pre_label: 'USER_TYPES.IFS',
  },
  {
    value: user_types.b2b,
    pre_label: 'USER_TYPES.B2B',
    only_dev: true,
  },
];

const online_affiliate_agreement = `${constants.partners_bucket}legal-documentation/NAGA-Online-Affiliate-Agreement.pdf`;
const introducer_agreement = `${constants.partners_bucket}legal-documentation/NAGA-Introducer-Agreement.pdf`;
const ifs_agreement = `${constants.partners_bucket}legal-documentation/NAGA-IFS-Agreement.pdf`;

const utm_params_cookie = 'utm_params';

const utm_params = {
  utm_source: 'utm_source',
  utm_medium: 'utm_medium',
  utm_content: 'utm_content',
  utm_campaign: 'utm_campaign',
  utm_keyword: 'utm_keyword',
  aff: 'aff',
  cid: 'cid',
  pid: 'pid',
  campaign_name: 'campaign_name',
  reason: 'reason',
  refcode: 'refcode',
};

export default {
  form_name,
  visible_all,
  fields,
  user_types,
  all_user_types,
  user_status,
  form_steps,
  status_options,
  currency_options,
  user_type_options,
  online_affiliate_agreement,
  introducer_agreement,
  ifs_agreement,
  utm_params_cookie,
  utm_params,
};



// WEBPACK FOOTER //
// ./src/app/main/register/constants/register-constants.js